import { DefaultError, useMutation } from "@tanstack/react-query";
import { readAllMessages } from "../api/readAllMessages";
import {
  invalidateCustomerTicketsQuery,
  QueryTicketsProps,
} from "../queries/useCustomerTicketsDataQuery";

type Params = QueryTicketsProps & {
  ticketId: string;
  onMutate: () => void;
};

export const useReorderTicketMessages = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ ticketId }) => {
      return await readAllMessages(ticketId);
    },
    onMutate: ({ onMutate }) => {
      onMutate();
    },
    onSuccess: async (_, { filters, query }) => {
      await invalidateCustomerTicketsQuery({ filters, query });
    },
    onError: (e) => {
      console.error("Error occurred when reordering ticket messages", e);
    },
  });
};
